import PropTypes from 'prop-types';
import MobileTabBar from './MobileTabBar';
import MobileDashboardPicker from './MobileDashboardPicker';
import logoDark from '../../assets/logo-dark.png';

/** Phone shell: slim branded header, scrolling content, bottom tab bar. No sidebar/toolbar/guide drawer. */
const MobileLayout = ({ children }) => (
	<div className="mobile-layout">
		<header className="mobile-header">
			<img src={logoDark} alt="Alert Panel" className="mobile-header__logo" />
			<MobileDashboardPicker />
		</header>
		<main className="mobile-content">{children}</main>
		<MobileTabBar />
	</div>
);

MobileLayout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MobileLayout;
